var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { stockDetails } from "./indexData";
export var findSymbol = function (dpName) {
    return stockDetails.find(function (x) { var _a; return ((_a = x === null || x === void 0 ? void 0 : x.dpCode) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (dpName === null || dpName === void 0 ? void 0 : dpName.toLowerCase()); });
};
export var findDisplayNameBySymbol = function (symbol) {
    return stockDetails.find(function (x) { return x.sym === symbol; });
};
export var findSymbolbyDpCode = function (symbol) {
    var stockDetail = stockDetails.find(function (x) { return x.sym === symbol; });
    if (stockDetail) {
        return __assign(__assign({}, stockDetail), { dpCode: stockDetail.sym });
    }
    return null;
};
export var symbolUpdate = function (symbol, type, symbols, allSymbols) {
    var _a;
    if (symbol) {
        if (symbol != "" && !(allSymbols === null || allSymbols === void 0 ? void 0 : allSymbols.includes(symbol))) {
            allSymbols.push(symbol);
        }
        if (symbol != "" && !((_a = symbols[type]) === null || _a === void 0 ? void 0 : _a.includes(symbol))) {
            symbols[type].push(symbol);
        }
    }
};
